import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
interface Permissions {
  routes: string[];
}
@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private permissions: Permissions;
  url = '@cec-api/auth';
  constructor(private http: HttpClient) {}

  authentication(email: string, password: string): Promise<any> {
    return this.http.post(this.url, { email, password }).toPromise();
  }

  setPermissions(permissions: any) {
    this.permissions = permissions;
  }

  getPermissions(): Permissions {
    return this.permissions;
  }

  changePassword(data): Promise<any> {
    return this.http.post('@cec-api/user/changePassword', data).toPromise();
  }

  sendEmailToRequestPassword(data): Promise<any> {
    return this.http.post('@cec-api/request-password', data).toPromise();
  }

  resetPassword(data, hash: string): Promise<any> {
    return this.http.put(`@cec-api/reset-password/${hash}`, data).toPromise();
  }
}
